// extracted by mini-css-extract-plugin
module.exports = {"next-btn-container":"TeamSignatureHighlightPopup_next-btn-container__702jn"};